import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import Spinner from './Spinner';

const Layout = ({ children }) => {
  useEffect(() => {
    // Hide spinner when component mounts
    const spinner = document.getElementById('spinner');
    if (spinner) {
      spinner.classList.remove('show');
    }
  }, []);

  return (
    <>
      <Spinner />
      <Header />
      <main>
        {children}
      </main>
      <Footer />
    </>
  );
};

export default Layout; 